export const UPDATE_TOURNAMENT_DATA_STATUS_DIALOG_TITLE = 'Tournament Data Status'
